<template>
  <v-container class="py-5">
    <v-card class="py-5" elevation="1">
      <v-card-title class="pa-8">
        <v-layout row wrap>
          <v-row>
            <h4 class="pl-4">Position Management Report</h4>
          </v-row>
          <v-spacer></v-spacer>
          <v-row class="pr-4 pt-2" justify="end">
            <v-btn
                class="mr-2"
                color="primary"
                @click="dataExportCSV"
            >
              <v-icon left>mdi-microsoft-excel</v-icon>
              Export Report to CSV
            </v-btn>
          </v-row>
        </v-layout>
      </v-card-title>
      <v-divider class="my-2"></v-divider>
      <v-card-actions class="px-8">
        <fhir-reference-report
            baseMax="1"
            baseMin="0"
            constraints=undefined
            edit=true
            field="partOf"
            initialValue="Location/federal-ministry-of-health"
            label="Facility"
            max="1"
            min="0"
            overrideValue=undefined
            path="Location.partOf"
            readOnlyIfSet:undefined
            returnAll=false
            sliceName:undefined
            slotProps:Object
            source:Object
            subFields:undefined
            targetProfile="http://ihris.org/fhir/StructureDefinition/ihris-facility"
            targetResource="Location"
            @selectedFacility="onSelectedFacility"
        >
        </fhir-reference-report>
        <v-text-field
            v-model="nameValue"
            label="Name"
            clearable
            dense
            hide-details
            outlined
            class="ma-2"
            @change="updateSearch()"
        >
        </v-text-field>
        <v-text-field
            v-model="codeValue"
            label="Code"
            clearable
            dense
            hide-details
            outlined
            class="ma-2"
            @change="updateSearch()"
        >
        </v-text-field>
        <v-text-field
            v-model="levelValue"
            label="Level"
            clearable
            dense
            hide-details
            outlined
            class="ma-2"
            @change="updateSearch()"
        >
        </v-text-field>
        <v-select
            v-model="professionCategoryValue"
            :error="error"
            :error-messages="err_messages"
            :items="professionCategoryItems.filter(x => !x.code.includes('(deactivated)'))"
            :loading="professionCategoryLoading"
            class="ma-2"
            clearable
            dense
            hide-details
            item-text="display"
            item-value="code"
            label="Profession Category"
            multiple
            outlined
            small-chips
            @change="updateSearch()"
            @click:clear="clearSearchProfessionCategory()"
        >
        </v-select>
        <v-select
            v-model="jobPositionValue"
            :error="error"
            :error-messages="err_messages"
            :items="jobPositionItems.filter(x => !x.code.includes('(deactivated)'))"
            :loading="jobPositionLoading"
            class="ma-2"
            clearable
            dense
            hide-details
            item-text="display"
            item-value="code"
            label="Job Position"
            multiple
            outlined
            small-chips
            @change="updateSearch()"
            @click:clear="clearSearchJobPosition()"
        >
        </v-select>
      </v-card-actions>
      <v-card-subtitle v-if="error_message" class="white--text error"
      >{{ error_message }}
      </v-card-subtitle>
      <v-card-text>
        <v-data-table
            :footer-props="{ 'items-per-page-options': [10,20,50] }"
            v-model="selected[0].data"
            :headers="headers"
            :items="desserts"
            class="elevation-1"
            item-key="name"
            loading="true"
            show-select
            :options.sync="options"
            :server-items-length="total"
            @page-count="pageCount = $event"
        >
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import axios from "axios";
import FhirReferenceReport from "../../components/fhir/fhir-referense-report";

export default {
  name: 'Position Management Report',
  components: {FhirReferenceReport},
  mounted: function () {
    this.professionCategoryLoading = true;
    this.jobPositionLoading = true;
    this.$fhirutils
        .expand("http://ihris.org/fhir/ValueSet/ihris-profession-category")
        .then((items) => {
          this.professionCategoryItems = items;
          this.professionCategoryLoading = false;
        })
        .catch((err) => {
          this.error = true;
          this.err_messages = err.message;
          this.professionCategoryLoading = false;
        });

    this.$fhirutils
        .expand("http://ihris.org/fhir/ValueSet/ihris-job-ethiopia")
        .then((items) => {
          this.jobPositionItems = items;
          this.jobPositionLoading = false;
        })
        .catch((err) => {
          this.error = true;
          this.err_messages = err.message;
          this.jobPositionLoading = false;
        });

  },
  watch:{
    options: {
      handler(val) {
        this.paginationFilter = true
        if(this.desserts.length<val.itemsPerPage){
          this.paginationFilter = false
        }
        if (this.desserts.length > 0) {
          this.getData();
        }
        // this.getData();
      },
      deep: true
    }
  },
  created() {
    this.getData();
  },
  data() {
    return {
      selected: [
        {
          name: "PositionStock",
          headers: [],
          data: []
        },
      ],
      jobPositionItems: [],
      professionCategoryItems: [],
      jobPositionValue: [],
      nameValue: "",
      codeValue: "",
      levelValue: "",
      professionCategoryValue: [],
      jobPositionLoading: false,
      professionCategoryLoading: false,
      headers: [],
      desserts: [],
      facilityId: [],
      error: false,
      err_messages: null,
      options: {itemsPerPage: 10, sortBy: ['facilityName']},
      total: 0,
      nextPage :undefined,
      previousPage:undefined,
      paginationFilter:false,
      isNext:false,
      pageCount: 0,
    }
  },
  methods: {
    onSelectedFacility(val) {
      if (val.length > 0) {
        this.facilityId = val.map(x => x.id.split('/').pop())
      } else if (val.length === 0) {
        this.facilityId = []
      }
      this.getData()
    },
    getData() {
      let data = {
        facility: this.facilityId,
        professionCategory: this.professionCategoryValue,
        jobPosition: this.jobPositionValue,
        name:this.nameValue,
        code:this.codeValue,
        level:this.levelValue,
        count:this.options.itemsPerPage,
        previousPage: this.previousPage,
        nextPage:this.nextPage,
        paginationFilter:this.paginationFilter
      }
      axios.post(`/es/positionReport`, data).then(({data}) => {
        this.headers = data.exportData.headers;
        this.desserts = data.exportData.data;
        this.total = data.exportData.total;
        this.nextPage = data.exportData?.nextPage
        this.previousPage = data.exportData?.previousPage
      })
          .catch(error => {
            this.error_message = error.message
          })
    },
    getDataToExport() {
      let data = []
      let returnAll = true;
      if (this.selected[0].data.length > 0) {
        returnAll = false;
      }
      if (returnAll) {
        data = [
          {
            name: "PositionStock",
            headers: this.headers,
            data: this.desserts
          },
        ]
      } else {
        this.selected[0].headers = this.headers
        data = this.selected
      }

      return data;
    },
    dataExportCSV() {
      let data = this.getDataToExport()
      axios.post(`/utils/exportExcel`, data, {
        responseType: "blob",
      })
          .then((response) => {
            console.log(response)
            let blob = new Blob([response.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = `Position_Management_Report_Exported_at_${new Date().toISOString()}.xlsx`
            link.click();
            this.loadingId = false;
          })
          .catch((e) => {
            console.log(e);
            this.loadingId = false;
          });
    },
    updateSearch: function () {
      this.getData()
    },
    clearSearchProfessionCategory: function () {
      this.professionCategoryItems = []
    },
    clearSearchJobPosition: function () {
      this.jobPositionValue = []
    }
  }
}
</script>
<style>
.basil {
  background-color: #FFFBE6 !important;
}
</style>